import {documentConstants, eSignConstants} from '../../constants/index';
import {alertActions} from '../index';
import {documentService, eSignService} from "../../services";

export const eSignActions = {
  getESignDocuments,
  getESignDocumentByID,
  uploadESignDocuments
};

function getESignDocuments(eSignSearch) {
  return dispatch => {
    dispatch(request());

    eSignService.getESignDocuments(eSignSearch)
      .then(
        eSignDocuments => {
          dispatch(success(eSignDocuments))
        },
        error => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
        }
      );
  };

  function request(eSignSearch) {
    return {type: eSignConstants.GET_ESIGN_LIST_REQUEST, eSignSearch}
  }

  function success(eSignDocuments) {
    return {type: eSignConstants.GET_ESIGN_LIST_SUCCESS, eSignDocuments}
  }

  function failure(error) {
    return {type: eSignConstants.GET_ESIGN_LIST_FAILURE, error}
  }
}

function getESignDocumentByID(documentId, accessToken) {
  return dispatch => {
    dispatch(request());

    eSignService.getESignDocumentById(documentId, accessToken)
      .then(
        eSignDocuments => {
          dispatch(success(eSignDocuments))
        },
        error => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
        }
      );
  };

  function request(eSignSearch) {
    return {type: eSignConstants.GET_ESIGN_DOCUMENT_REQUEST, eSignSearch}
  }

  function success(eSignDocuments) {
    return {type: eSignConstants.GET_ESIGN_DOCUMENT_SUCCESS, eSignDocuments}
  }

  function failure(error) {
    return {type: eSignConstants.GET_ESIGN_DOCUMENT_FAILURE, error}
  }
}

function uploadESignDocuments(eSignData) {
  return dispatch => {
    dispatch(request(eSignData));

    eSignService.uploadESignDocuments(eSignData)
      .then(
        eSignListUploaded => {
          dispatch(success(eSignListUploaded));
          if (eSignListUploaded.statusCode === 200) {
            if ((eSignListUploaded.data.failedUploads).length === 0) {
              dispatch(alertActions.success(eSignListUploaded.data.message));
            } else {
              dispatch(alertActions.warning(eSignListUploaded.data.message));
            }
          } else {
            dispatch(alertActions.warning(eSignListUploaded.data.message));
          }
        },
        error => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
        }
      );
  };

  function request(eSignData) {
    return {type: eSignConstants.UPLOAD_FILES_REQUEST, eSignData}
  }

  function success(eSignListUploaded) {
    return {type: eSignConstants.UPLOAD_FILES_SUCCESS, eSignListUploaded}
  }

  function failure(error) {
    return {type: eSignConstants.UPLOAD_FILES_FAILURE, error}
  }
}

// function uploadDocuments(uploadFields) {
//   return dispatch => {
//     dispatch(request(uploadFields));
//
//     documentService.uploadDocuments(uploadFields)
//       .then(
//         fileListUploaded => {
//           dispatch(success(fileListUploaded));
//           if (fileListUploaded.statusCode === 200) {
//             if ((fileListUploaded.data.failedUploads).length === 0) {
//               dispatch(alertActions.success(fileListUploaded.data.message));
//             } else {
//               dispatch(alertActions.warning(fileListUploaded.data.message));
//             }
//           } else {
//             dispatch(alertActions.warning(fileListUploaded.data.message));
//           }
//         },
//         error => {
//           dispatch(failure(error.toString()));
//           dispatch(alertActions.error(error.toString()));
//         }
//       );
//   };
//
//   function request(uploadFields) {
//     return {type: documentConstants.UPLOAD_FILES_REQUEST, uploadFields}
//   }
//
//   function success(fileListUpload) {
//     return {type: documentConstants.UPLOAD_FILES_SUCCESS, fileListUpload}
//   }
//
//   function failure(error) {
//     return {type: documentConstants.UPLOAD_FILES_FAILURE, error}
//   }
// }
